import { render, staticRenderFns } from "./CaseReportTable.vue?vue&type=template&id=5569f8bc&"
import script from "./CaseReportTable.vue?vue&type=script&lang=js&"
export * from "./CaseReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports